import { LectureMaster } from './LectureMaster.model';
import { ContentMaster } from './ContentMaster.model';
import { DocumentMaster } from './DocumentMaster.model';

export class LectureContentMaster{
    public lectureContentMasterId:number;
    public lectureMaster:LectureMaster;
    public contentMaster:ContentMaster;
    public documentMaster:DocumentMaster;
}